module.exports = __webpack_public_path__ + "static/img/1.20bff89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/sp/1.png
// module id = EYUD
// module chunks = 0